import React from 'react'
import Breadcrumb from './Breadcrumb'
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Blogarea from './Blogarea'
import BlogArea from './related-blogs';



function Blogs() {
  return (
	<>
	<HeaderTwo/>
	<main>
	<Blogarea/>
	</main>
	<Footer/>
	
	</>
  )
}

export default Blogs